import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import BrandMark from "@/components/common/BrandMark";
import { useI18n } from "@/i18n";

export default function ResetPassword() {
  const { token } = useParams();
  const { t } = useI18n();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    if (password.length < 10 || password !== confirm) {
      setError(password !== confirm ? t("errors.passwords_do_not_match") : t("auth.password_minimum"));
      return;
    }
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, new_password: password }, { _skipAuthRedirect: true });
      setDone(true);
    } catch {
      setError(t("auth.reset_invalid"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6 dark:bg-slate-950">
      <div className="w-full max-w-sm rounded-xl border bg-white p-6 shadow-sm dark:border-slate-800 dark:bg-slate-900">
        <BrandMark className="mb-6 h-10 w-10" />
        <h1 className="font-heading text-2xl font-bold">{t("auth.reset_title")}</h1>
        {done ? (
          <p className="mt-3 text-sm text-emerald-700 dark:text-emerald-400">{t("auth.reset_done")}</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div className="space-y-1.5"><Label htmlFor="new-password">{t("settings.new_password")}</Label>
              <Input id="new-password" type="password" autoComplete="new-password" required value={password}
                onChange={(event) => setPassword(event.target.value)} /></div>
            <div className="space-y-1.5"><Label htmlFor="confirm-password">{t("settings.confirm_password")}</Label>
              <Input id="confirm-password" type="password" autoComplete="new-password" required value={confirm}
                onChange={(event) => setConfirm(event.target.value)} /></div>
            {error && <p className="text-sm text-red-600" role="alert">{error}</p>}
            <Button type="submit" className="w-full" disabled={busy}>{t("auth.save_new_password")}</Button>
          </form>
        )}
        <Link to="/login" className="mt-5 block text-center text-sm text-primary hover:underline">{t("auth.back_to_login")}</Link>
      </div>
    </div>
  );
}
